import { render, staticRenderFns } from "./PanelCompetitionResult.vue?vue&type=template&id=b1d4085c&scoped=true&"
import script from "./PanelCompetitionResult.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionResult.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionResult.vue?vue&type=style&index=0&id=b1d4085c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d4085c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1d4085c')) {
      api.createRecord('b1d4085c', component.options)
    } else {
      api.reload('b1d4085c', component.options)
    }
    module.hot.accept("./PanelCompetitionResult.vue?vue&type=template&id=b1d4085c&scoped=true&", function () {
      api.rerender('b1d4085c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionResult.vue"
export default component.exports